export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9194.6fbba626.jpg";